import React, { Fragment } from 'react'
import CardEmpty from "../../../../Utils/Cards/CardEmpty";
import { RenderGramos, RenderKilogramo, RenderNumber, RenderNumberPercentage } from '../../../../Utils/renderField/renderReadField';
import { getColorVariacionDRC } from '../../../../Utils/LaboratorioDRC/Common';
import { calcularDRCSolidosOriginal } from '../../../../Utils/LaboratorioDRC/CalculosDRCSolidos';
import "react-step-progress-bar/styles.css";
import './DatosDRC.css';

/**
 * Componente para renderizar los datos de DRC
 * @param {*} props propiedades del componente
 * @param {object} props.item objeto con los datos de DRC
 * @param {boolean} props.verVariacionDRC indica si se debe mostrar la variación DRC
 * @returns {JSX.Element} componente de datos de DRC
 */
export const DatosDRC = (props) => {
    const { item, verVariacionDRC } = props;

    const registrosDRC = item.datos_drc || [];

    return (
        <CardEmpty noShadow >
            <div className="row col-12 m-0 py-3 datos-drc-solidos-ver__container">
                <div className="col-12 responsive-table-fix">
                    <div className="d-flex justify-content-between my-2">
                        <h6 className="">DATOS DRC</h6>
                        {verVariacionDRC &&
                            <div className="d-flex align-items-center">
                                <span className="verde-secundario bold mr-2 ml-3">VARIACIÓN DRC:</span>
                                {item.aplica_variacion_drc ?
                                    <RenderNumber value={item.variacion_drc} suffix=" %" decimalScale={2}
                                        className={getColorVariacionDRC(item.variacion_drc)} /> :
                                    <span className="gris">NO APLICADA</span>
                                }
                            </div>
                        }
                    </div>
                    <div className="new-table-wrapper pd-small mt-3">
                        <table >
                            <thead className="table-header">
                                <tr>
                                    <th />
                                    <th className="text-right">PESO MUESTRA</th>
                                    <th className="text-right">PESO CREPA</th>
                                    <th className="text-right">PH1</th>
                                    <th className="text-right">PH2</th>
                                    <th className="text-right">PH3</th>
                                    {item.aplica_variacion_drc && verVariacionDRC ?
                                        <Fragment>
                                            <th className="text-right">PS1 ORIGINAL</th>
                                            <th className="text-right">PS2 ORIGINAL</th>
                                            <th className="text-right">PS3 ORIGINAL</th>
                                            <th className="text-right datos-drc-solidos-ver__tbl-long-name">PS1 CON VARIACIÓN DRC</th>
                                            <th className="text-right datos-drc-solidos-ver__tbl-long-name">PS2 CON VARIACIÓN DRC</th>
                                            <th className="text-right datos-drc-solidos-ver__tbl-long-name">PS3 CON VARIACIÓN DRC</th>
                                            <th className="text-right">DRC1 ORIGINAL</th>
                                            <th className="text-right">DRC2 ORIGINAL</th>
                                            <th className="text-right">DRC3 ORIGINAL</th>
                                            <th className="text-right">DRC1 CON VARIACIÓN</th>
                                            <th className="text-right">DRC2 CON VARIACIÓN</th>
                                            <th className="text-right">DRC3 CON VARIACIÓN </th>
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <th className="text-right">PS1</th>
                                            <th className="text-right">PS2</th>
                                            <th className="text-right">PS3</th>
                                            <th className="text-right">DRC1</th>
                                            <th className="text-right">DRC2</th>
                                            <th className="text-right">DRC3</th>
                                        </Fragment>
                                    }
                                    <th className="text-right">DRC PROMEDIO</th>
                                    <th>HORA INGRESO</th>
                                    <th>HORA SALIDA</th>
                                    <th>LABORATORISTA</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {registrosDRC.map((pago, index) => {
                                    const dato_actual = item.datos_drc[index]; // Dato actual

                                    const celdaClassName = (dato_actual.activo !== undefined && dato_actual.activo === false) ? 'tachado' : '';

                                    // DRC originales
                                    const { drc1_original, drc2_original, drc3_original } = calcularDRCSolidosOriginal(dato_actual);

                                    return (
                                        <tr key={index} >
                                            <td />
                                            <td
                                                label="PESO MUESTRA"
                                                className={`${celdaClassName} text-right td--no-wrap`}>
                                                <RenderKilogramo value={dato_actual.peso_muestra} />
                                            </td>
                                            <td
                                                label="PESO CREPA"
                                                className={`${celdaClassName} text-right td--no-wrap`}>
                                                <RenderKilogramo value={dato_actual.peso_crepa} />
                                            </td>
                                            <td
                                                label="PH1"
                                                className={`${celdaClassName} text-right td--no-wrap`}>
                                                <RenderGramos value={dato_actual.peso_humedo_1} />
                                            </td>
                                            <td
                                                label="PH2"
                                                className={`${celdaClassName} text-right td--no-wrap`}>
                                                <RenderGramos value={dato_actual.peso_humedo_2} />
                                            </td>
                                            <td
                                                label="PH3"
                                                className={`${celdaClassName} text-right td--no-wrap`}>
                                                <RenderGramos value={dato_actual.peso_humedo_3} />
                                            </td>
                                            {item.aplica_variacion_drc && verVariacionDRC ?
                                                <Fragment>
                                                    <td
                                                        label="PS1 ORIGINAL"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        <RenderGramos value={dato_actual.peso_seco_1_original} />
                                                    </td>
                                                    <td
                                                        label="PS2 ORIGINAL"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        <RenderGramos value={dato_actual.peso_seco_2_original} />
                                                    </td>
                                                    <td
                                                        label="PS3 ORIGINAL"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        <RenderGramos value={dato_actual.peso_seco_3_original} />
                                                    </td>
                                                    <td
                                                        label="PS1 CON VARIACIÓN DRC"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        <RenderGramos value={dato_actual.peso_seco_1} />
                                                    </td>
                                                    <td
                                                        label="PS2 CON VARIACIÓN DRC"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        <RenderGramos value={dato_actual.peso_seco_2} />
                                                    </td>
                                                    <td
                                                        label="PS3 CON VARIACIÓN DRC"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        <RenderGramos value={dato_actual.peso_seco_3} />
                                                    </td>

                                                    <td label="DRC1 ORIGINAL"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        {drc1_original ?
                                                            <RenderNumberPercentage value={parseFloat(drc1_original)} /> : '--'
                                                        }
                                                    </td>
                                                    <td label="DRC2 ORIGINAL"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        {drc2_original ?
                                                            <RenderNumberPercentage value={parseFloat(drc2_original)} /> : '--'
                                                        }
                                                    </td>
                                                    <td label="DRC3 ORIGINAL"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        {drc3_original ?
                                                            <RenderNumberPercentage value={parseFloat(drc3_original)} /> : '--'
                                                        }
                                                    </td>
                                                </Fragment>
                                                :
                                                <Fragment>
                                                    <td
                                                        label="PS1"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        <RenderGramos value={dato_actual.peso_seco_1_original} />
                                                    </td>
                                                    <td
                                                        label="PS2"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        <RenderGramos value={dato_actual.peso_seco_2_original} />
                                                    </td>
                                                    <td
                                                        label="PS3"
                                                        className={`${celdaClassName} text-right td--no-wrap`}>
                                                        <RenderGramos value={dato_actual.peso_seco_3_original} />
                                                    </td>
                                                </Fragment>
                                            }
                                            <td label="DRC1"
                                                className={`${celdaClassName} text-right td--no-wrap`}>
                                                {dato_actual.drc_promedio_1 ?
                                                    <RenderNumberPercentage value={parseFloat(dato_actual.drc_promedio_1)} /> : '--'
                                                }
                                            </td>
                                            <td label="DRC2"
                                                className={`${celdaClassName} text-right td--no-wrap`}>
                                                {dato_actual.drc_promedio_2 ?
                                                    <RenderNumberPercentage value={parseFloat(dato_actual.drc_promedio_2)} /> : '--'
                                                }
                                            </td>
                                            <td label="DRC3"
                                                className={`${celdaClassName} text-right td--no-wrap`}>
                                                {dato_actual.drc_promedio_3 ?
                                                    <RenderNumberPercentage value={parseFloat(dato_actual.drc_promedio_3)} /> : '--'
                                                }
                                            </td>
                                            <td className={`${celdaClassName} text-right td--no-wrap`}>
                                                {dato_actual.drc_promedio_total ? <RenderNumberPercentage value={parseFloat(dato_actual.drc_promedio_total)} /> : '--'}
                                            </td>

                                            <td className={`${celdaClassName}`}>
                                                <span>{dato_actual.hora_ingreso} </span>
                                            </td>
                                            <td className={`${celdaClassName}`}>
                                                <span>{dato_actual.hora_salida} </span>
                                            </td>
                                            <td className={`${celdaClassName}`}>
                                                <span>{dato_actual.laboratorista_nombre ? dato_actual.laboratorista_nombre : dato_actual.laboratorista.nombre} </span>
                                            </td>
                                            <td />
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </CardEmpty>
    )
}
